import { Link } from 'react-router-dom';
import { films } from '@/mocks/films';
import { sortFilms } from '@/utils/content';

export default function PopularRanking() {
  const ranked = sortFilms(films, 'popular').slice(0, 5);

  return (
    <div className="rounded-lg border border-background-300/70 bg-background-100 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-[14px] font-medium text-foreground-900">
          <i className="ri-fire-line text-primary-500" />
          本周热度排行
        </h3>
        <span className="font-label text-[10px] tracking-wider text-foreground-500">TOP 5</span>
      </div>
      <ol className="space-y-1">
        {ranked.map((film, index) => (
          <li key={film.id}>
            <Link
              to={`/detail/${film.id}`}
              className="group flex cursor-pointer items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-200/70"
            >
              <span
                className={`w-5 shrink-0 text-center font-heading text-[15px] font-semibold ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-500'
                }`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="h-14 w-10 shrink-0 overflow-hidden rounded border border-background-300/60 bg-background-200">
                <img src={film.cover} alt={`${film.title} 封面`} className="h-full w-full object-cover object-top" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[13px] text-foreground-900 transition-colors group-hover:text-primary-400">
                  {film.title}
                </span>
                <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                  {film.year} · {film.region}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-1 text-[11px] text-foreground-600">
                <i className="ri-star-fill text-[9px] text-primary-500" />
                {film.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ol>
      <Link
        to="/search"
        className="mt-4 flex items-center justify-center gap-1.5 rounded-md border border-background-300 py-2.5 text-[12px] text-foreground-700 transition-colors hover:border-primary-500/60 hover:text-primary-400"
      >
        查看全部条目
        <i className="ri-arrow-right-line" />
      </Link>
    </div>
  );
}